import { render, staticRenderFns } from "./course_comment_each.vue?vue&type=template&id=4305cb02&scoped=true"
import script from "./course_comment_each.vue?vue&type=script&lang=js"
export * from "./course_comment_each.vue?vue&type=script&lang=js"
import style0 from "./course_comment_each.vue?vue&type=style&index=0&id=4305cb02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4305cb02",
  null
  
)

export default component.exports